module.exports = __webpack_public_path__ + "img/8-02_mb.0556870d.png";